import { createContext } from 'react';
import useUsers from '../Feed/hooks/useUsers';
import useNews from '../Feed/hooks/useNews';
import useFeedConfig from '../Feed/hooks/useFeedConfig';

export const FeedContext = createContext<{
  /** Whether to record impressions and newsfeed_story_views */
  useReporting: boolean;
  /** Whether to record user_viewed_social_* for the algorithm */
  recordViews: boolean;
  /** Feed-level user actions */
  userActions: ReturnType<typeof useUsers>;
  /** Feed-level news actions */
  newsActions: ReturnType<typeof useNews>;
  /** Feed-level configuration */
  feedConfig: ReturnType<typeof useFeedConfig>;
  /** Show beta inline paper reader */
  showInlineReader?: boolean;
  /** Whether to show AI summary buttons */
  showAiButtons?: boolean;
  /** Whether to show social actions */
  showSocialActions?: boolean;
  /** Whether we're using the new Activation Overhaul experience */
  inActivationOverhaul?: boolean;
  /** Whether to show dense desktop */
  showDenseDesktop?: boolean;
  /** Whether to show ratings for news items */
  showRatings?: boolean;
}>({
  useReporting: true,
  recordViews: true,
  userActions: {} as ReturnType<typeof useUsers>,
  newsActions: {} as ReturnType<typeof useNews>,
  feedConfig: {} as ReturnType<typeof useFeedConfig>,
  showInlineReader: false,
  showAiButtons: false,
  showSocialActions: false,
  inActivationOverhaul: false,
  showDenseDesktop: false,
  showRatings: false,
});
